import { observable, action } from 'mobx';
import { getUserInfo, getToken, userRefresh } from '../../api/fwApi/webpdfapi';
import { accounts } from '../../api/fwApi/account';
import { vipTokens } from '../../api/fwApi/vip';
import { store } from '../store.index';
import { isMobile, isMacSsoNoIos } from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
import utils from '@foxit/utils';
import jsonp from 'jsonp';
import { collaborationApi } from 'Api/index';
import { cookies } from 'Api/index';
import { IamLogout } from 'Api/fwApi/login';
// import { getCookie } from 'Utils/utils';

class userNewStore {
  @observable userData = null;
  // @observable userData = {
  //   companyName: null,
  //   editVip: false,
  //   email: "",
  //   figure: "",
  //   identity: "vip",
  //   nickname: "风",
  //   openIdType: "tel",
  //   packageType: null,
  //   permission: true,
  //   roleName: null,
  //   superVip: true,
  //   tel: "17689380105",
  //   userId: 900043158
  // };
  @observable fId = '';
  @observable realName = false; // 是否实名认证
  @observable userToken = ''; // 用户token
  @observable isBusinessUser = false; // 是否企业用户
  @observable abnormalAccount = false; // 是否账号异常用户
  @observable myInterval = null;
  @observable firstLogin = 0;
  @observable getUserNewCount = false;
  @observable vipToken = '';
  @observable accountList = [];

  @action setRealName(val) {
    this.realName = val;
  }
  // getUser专用接口，只用于处理用户数据读取
  @action userInfo() {
    const config = {
      headers: {
        client: 'editCloud',
      },
      params: {
        token: utils.util.getQueryString('token'),
        v: new Date().getTime(),
      },
    };
    getUserInfo(config)
      .then((res) => {
        if (res.ret === 0) {
          this.setUserInfo(res.data);
          this.setUserFid(utils.util.getQueryString('fid'));
          // 用户登入后使用fid获取用户token缓存下来
          // 获取token逻辑修改，用户若当前没有token信息，则获取token
          // this.userToken = cookies.get('fwShareToken')
          store.loginNewStore.setIsLogin(true);
          let { IAMToken } = store.loginNewStore;
          this.firstLogin++;
          // 为协同操作注入token
          if (IAMToken) {
            localStorage.setItem('token', IAMToken);
            this.updateToken(IAMToken);
            collaborationApi.setToken(IAMToken);
            this.userToken = IAMToken;
            this.getAccounts();
          } else {
            this.getToken();
          }
        } else {
          this.setUserInfo();
          store.loginNewStore.setIsLogin(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  @action getUserNew() {
    // 获取用户信息限流
    if (this.getUserNewCount) {
      return;
    }
    this.getUserNewCount = true;
    setTimeout(() => {
      this.getUserNewCount = false;
    }, 500);
    // 获取用户信息，未登录则跳转登录
    const config = {
      headers: {
        client: 'editCloud',
      },
      params: {
        token: utils.util.getQueryString('token'),
        v: new Date().getTime(),
      },
    };
    getUserInfo(config)
      .then((res) => {
        if (res.ret === 0) {
          this.setUserInfo(res.data);
          this.setUserFid(utils.util.getQueryString('fid'));
          // 用户登入后使用fid获取用户token缓存下来
          // 获取token逻辑修改，用户若当前没有token信息，则获取token
          // this.userToken = cookies.get('fwShareToken')
          store.loginNewStore.setIsLogin(true);
          let { IAMToken } = store.loginNewStore;
          this.firstLogin++;
          // 为协同操作注入token
          if (IAMToken) {
            localStorage.setItem('token', IAMToken);
            this.updateToken(IAMToken);
            collaborationApi.setToken(IAMToken);
            this.userToken = IAMToken;
            this.getAccounts();
            // 去除首页弹窗
            let LoginBox = document.getElementById('firstPageLoginBox');
            LoginBox.style.display = 'none';
          } else {
            this.getToken();
          }
        } else if (res.ret === 401) {
          // 登录态失效，重新获取token
          this.userToken = '';
          this.setUserInfo();
          store.loginNewStore.setIsLogin(false);
          if (this.firstLogin < 1) {
            this.firstLogin++;
            !isMobile && store.advertStore.getAdvert();
          } else {
            //   store.loginNewStore.login();
            // setTimeout(() => {
            //   store.loginNewStore.login();
            // }, 500)
            // store.common.isLoginLoseDialog = true
          }
        }
        // 首屏骨架屏loading
        let firstPageLoading = document.getElementById('firstPageLoading');
        firstPageLoading.style.display = 'none';
      })
      .catch((err) => {
        console.log(err);
      });
  }
  @action getToken() {
    getToken().then(
      (res) => {
        if (res.ret === 0) {
          this.userToken = res.data;
          localStorage.setItem('token', res.data);
          // 为协同操作注入token
          this.updateToken(this.userToken, true);
          collaborationApi.setToken(this.userToken);
          store.loginNewStore.setIsLogin(true);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }
  @action setUserInfo(userData) {
    // 数据处理，因IAM账号信息同SSO信息有区别，这里做一个统一处理，不局部调整原有信息字段
    if (userData) {
      // let data = {...userData, figure: userData.avatar, nickname: userData.nickName, tel: userData.phone}
      let data = { ...userData };
      this.userData = data;
      this.isBusinessUser = data.accountType === 2 || data.accountType === 'COMPANY'; // 1、个人；2、企业用户
      this.setAbnormalAccount(userData.permission);
      if (this.userToken) {
        // 以获取token，则保存登录态
        store.loginNewStore.setIsLogin(true);
      }
      window.pdfui && window.pdfui.setUserName(userData.nickname);
    } else {
      this.userData = null;
      this.userToken = '';
      // this.setAbnormalAccount(true)
    }
  }
  @action setUserFid(id) {
    this.fId = id;
  }
  @action setAbnormalAccount(permission) {
    // permission： true 有权限 false没权限，当无权限时当前用户账号异常，退出登入并弹窗提示
    let that = this;
    debugger;
    function intervalPermission() {
      let wxToken = utils.util.getQueryString('token');
      const config = wxToken
        ? {
            params: {
              token: wxToken,
            },
          }
        : {};
      userRefresh(config)
        .then((res) => {
          if (res.ret === 0 && !res.data) {
            clearInterval(that.myInterval);
            that.myInterval = null;
            // 后台session被清空后，用户还在请求的，false需要处理为登录异常并清除定时
            // 判断前重新获取一次userInfo,判断用户是否有权限
            const config = {
              headers: {
                client: 'editCloud',
              },
              params: {
                token: utils.util.getQueryString('token'),
              },
            };
            getUserInfo(config)
              .then((res) => {
                console.log(3);
                if (res.ret === 0) {
                  if (res.data.permission) {
                    that.setUserInfo(res.data);
                  } else {
                    that.abnormalAccount = true;
                    that.userData = {};
                  }
                } else if (res.ret === 401) {
                  // 登录态失效，重新获取token
                  this.userToken = '';
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else if (res.ret === 407 || res.ret === 401) {
            // IAM 环境token失效，调用登录,用于处理单点登录
            // if (store.loginNewStore.IAMToken) {
            //   store.loginNewStore.login();
            // }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 无权限，但是cookie的token没有，说明清楚了cookie，直接报登录失效

    if (permission && !this.myInterval) {
      // 有权限用户 启动心跳定时服务 5 分钟请求一次
      // let interval = 4 * 60 * 1000

      let interval = 55 * 1000;
      intervalPermission();
      this.myInterval = setInterval(() => {
        intervalPermission();
      }, interval);
    }
    if (!permission && this.myInterval) {
      clearInterval(this.myInterval);
      this.myInterval = null;
    }
    if (!permission) {
      if (store.loginNewStore.isLoginAfterClearCookie) {
        IamLogout({
          params: {
            userId: store.userNewStore.userData.userId,
          },
        }).then(() => {
          debugger;
          console.log('打印测试清除成功清除成功清除成功');
        });
        store.common.isShowLoginLoseDialog = true;
        store.loginNewStore.setIsLoginAfterClearCookie(false);
        return;
      }
    }
    if (!permission && !this.myInterval) {
      this.userData = {};
    }

    this.abnormalAccount = !permission;
  }

  @action checkVip() {
    // !是否会员鉴权，改为触发鉴权时就会触发
    const config = {
      headers: {
        client: 'editCloud',
      },
      params: {
        token: utils.util.getQueryString('token'),
      },
    };
    return new Promise((resolve, reject) => {
      getUserInfo(config)
        .then((res) => {
          console.log(4);
          if (res.ret === 0) {
            this.setUserInfo(res.data);
            resolve(res.data.identity);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // 验证是否实名及获取实名验证码
  @action getVipTokens() {
    return new Promise((resolve, reject) => {
      let config = {};
      config.fid = window.readerCookies.fid;
      vipTokens(config)
        .then((res) => {
          if (res.ret === 0) {
            this.vipToken = res.data.token;
          }
          resolve(res.data.token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  @action isRealName(tel) {
    //! 验证是否实名，ret返回1019或1004
    //! 认证，ret===0
    let url = `https://vip.foxitreader.cn/v2/sendTelMsg_certification?${tel ? 'tel=' + tel : null}`;
    let options = { param: 'jsonpcallback' };
    if (isMacSsoNoIos || isSafari) {
      if (this.vipToken) {
        url += `&token=${this.vipToken}&platform=pc`;
        return new Promise((resolve, reject) => {
          jsonp(url, options, (err, data) => {
            if (!err) {
              resolve(data);
            } else {
              reject(err);
            }
          });
        });
      } else {
        return this.getVipTokens().then((res) => {
          url += `&token=${res}&platform=pc`;
          return new Promise((resolve, reject) => {
            jsonp(url, options, (err, data) => {
              if (!err) {
                resolve(data);
              } else {
                reject(err);
              }
            });
          });
        });
      }
    } else {
      return new Promise((resolve, reject) => {
        jsonp(url, options, (err, data) => {
          if (!err) {
            resolve(data);
          } else {
            reject(err);
          }
        });
      });
    }
  }
  @action setBindTel(tel, code) {
    let url = `https://vip.foxitreader.cn/v2/doCertificate?&tel=${tel}&code=${code}`;
    let options = { param: 'jsonpcallback' };
    if (isMacSsoNoIos || isSafari) {
      if (this.vipToken) {
        url += `&token=${this.vipToken}&platform=pc`;
        return new Promise((resolve, reject) => {
          jsonp(url, options, (err, data) => {
            if (!err) {
              resolve(data);
            } else {
              reject(err);
            }
          });
        });
      } else {
        return this.getVipTokens().then((res) => {
          url += `&token=${res}&platform=pc`;
          return new Promise((resolve, reject) => {
            jsonp(url, options, (err, data) => {
              if (!err) {
                resolve(data);
              } else {
                reject(err);
              }
            });
          });
        });
      }
    } else {
      return new Promise((resolve, reject) => {
        jsonp(url, options, (err, data) => {
          if (!err) {
            resolve(data);
          } else {
            reject(err);
          }
        });
      });
    }
  }
  // 从online移植的保存token接口，用于协同功能
  @action async updateToken(token, keepCookie) {
    // this.token = token;
    if (store.teamsAppStore.inTeamsApp) {
      return;
    }
    window.sessionStorage.setItem('driver_access_token', token);
    if (keepCookie) {
      let date = new Date();
      date.setTime(Date.now() + 2 * 60 * 60 * 1000);
      cookies.set('fwShareToken', token, { path: '/', expires: date });
      // cookies.set('currentToken', token, { path: '/', expires: date });
    }
  }
  // IAM 用户可切换列表
  @action getAccounts() {
    accounts().then((res) => {
      console.log(res);
      if (res.code === 0) {
        this.accountList = res.data;
      }
    });
  }
}

export default userNewStore;
